import { createAction, isActionOf } from 'typesafe-actions'
import { Event, isCommentEvent, isObjectEvent, isProjectEvent, isTaskEvent } from '../../responses/events'
import { Epic } from 'redux-observable'
import { filter, mergeMap } from 'rxjs/operators'
import { concat, EMPTY, from, of } from 'rxjs'
import { tagActions } from '../data/tag'
import { projectActions } from '../data/project/project-actions'
import { taskActions } from '../data/task/task-actions'
import { RootEpic } from '../root'
import { objectActions } from '../data/object/object-actions'
import { historyActions } from './history/history-actions'

export const eventActions = {
    event: createAction('@EVENTS/EVENT')<Event>(),
}

const distributeEvents: RootEpic = action$ => action$.pipe(
    filter(isActionOf(eventActions.event)),
    mergeMap(({ payload }) => {
        if (isProjectEvent(payload)) {
            switch (payload.action) {
                case 'add':
                    return of(projectActions.create.success(payload.model, 'system'))
                case 'delete':
                    return of(projectActions.remove.success(payload.model.id))
                case 'update':
                    return of(projectActions.update.success(payload.model, 'system'))
            }
        }
        if (isObjectEvent(payload)) {
            if (payload.action === 'update') {
                const objectId = payload.model.id
                return concat(
                    of(objectActions.update.success(payload.model, 'system')),
                    payload.model.tags ? of(tagActions.list.success({ [objectId]: payload.model.tags || [] })) : EMPTY
                )
            }
        }
        if (isTaskEvent(payload)) {
            switch (payload.action) {
                case 'add':
                    return of(taskActions.create.success(payload.model, 'system'))
                case 'delete':
                    return from([
                        taskActions.remove.success(payload.model.id),
                    ])
                case 'update':
                    return from([
                        taskActions.update.success(payload.model, 'system'),
                        objectActions.update.success(payload.model.project_work_object, 'system'),
                    ])
            }
        }
        if (isCommentEvent(payload)) {
            switch (payload.action) {
                case 'update':
                    return of(historyActions.comment.success(payload.model, 'system'))
                case 'delete':
                    return of(historyActions.delete.success(payload.model.id))
            }
        }
        return EMPTY
    })
)

export const eventsEpic: Epic = distributeEvents